import React from 'react';
import '../pages/About.css';

const AboutUs = () => {
  return (
    <div className="about-us">
      <h1>About Our Company</h1>
      <p>
        We are a leading industrial manufacturing company specializing in high-precision machinery and automation.
      </p>

      <div className="about-section">
        <div className="about-image-wrapper">
          <img src="/images/building.jpg" alt="Company Building" className="about-image" />
        </div>
        <div className="about-text">
          <h2>Our Mission</h2>
          <p>
            At Minerva Precision, we are committed to engineering excellence and sustainable growth. Through relentless
            innovation, ethical business practices, and a customer-centric approach, we deliver superior-quality moulds
            and dies that drive efficiency and precision in manufacturing.
            Our mission is to empower our employees, delight our customers, and create lasting value for all stakeholders,
            fostering a future of excellence and sustainability.
          </p>
        </div>
      </div>

      <div className="about-section reverse">
        <div className="about-image-wrapper">
          <img src="/images/innovation.jpg" alt="Innovation" className="about-image" />
        </div>
        <div className="about-text">
          <h2>Our Vision</h2>
          <p>
            To be the world's most trusted and innovative provider of <strong>high-quality moulds and dies</strong>, 
            setting new industry benchmarks through precision, sustainability, and technological excellence.
            We aspire to transform manufacturing with <strong>cutting-edge solutions</strong> that empower businesses 
            and enhance global production standards.
          </p>
        </div>
      </div>

      <div className="about-section">
        <div className="about-image-wrapper">
          <img src="/images/ISO Certificate.jpg" alt="ISO Certification" className="about-image" />
        </div>
        <div className="about-text">
          <h2>ISO Certified</h2>
          <p>
            Minerva Precision is proudly certified by <strong>TUV SOUTH ASIA PVT LTD</strong>, having successfully 
            implemented a Quality Management System in accordance with <strong>ISO 9001:2015</strong>.
            This certification covers the manufacture and supply of moulds and dies, ensuring adherence to international 
            quality standards.
            As an <strong>ISO-certified company</strong>, we uphold the highest standards of reliability and precision.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
